import { useMemo } from "react"
import _ from "lodash"
import { EXTENSION_NAME } from "../../constant"
import { useExtension } from "hooks/extension/useExtension"

interface IHelpCentre {
  descriptions: {
    en: string
    th: string
  }
  contacts: string[]
}

interface UseContactResult {
  helpCentre: IHelpCentre | null
}

const DEFAULT_CONFIG = {
  descriptions: null,
  contacts: [],
}

export const useContact = (): UseContactResult => {
  const { extensionConfig } = useExtension()

  const helpCentre = useMemo(() => {
    const config = _.get(
      extensionConfig,
      `${EXTENSION_NAME}.options.helpCentre`,
      {}
    ) as IHelpCentre
    return _.merge({}, DEFAULT_CONFIG, config)
  }, [extensionConfig])

  return {
    helpCentre,
  }
}
